import { HELP_OPTIONS } from '@aytm/app/stats/page/question-views/components/lib/constants'

export const getChartTopsMapping = (qType, batches, maxAnswerPosition) => {
  const chartTopsMapping = []

  let answerVariants = batches.find(b => b?.answerVariants)?.answerVariants || []
  answerVariants = answerVariants.slice().filter(av => av && (!Object.hasOwn(av, 'positive') || av.positive))

  const reversed = ['sr', 'se'].includes(qType) || maxAnswerPosition > 1
  if (reversed) {
    answerVariants.reverse()
  }

  const len = answerVariants.length

  if (len > 1) {
    const av = answerVariants[0]
    chartTopsMapping.push({
      value: reversed ? 'bottom1' : 'top1',
      listText: `Top 1 Box (A${av.position}: ${av.text})`,
      text: 'Top 1 Box'
    })
  }
  if (len > 2) {
    const [av0, av1] = answerVariants
    chartTopsMapping.push({
      value: reversed ? 'bottom2' : 'top2',
      listText: `Top 2 Box (A${av0.position}: ${av0.text}, A${av1.position}: ${av1.text})`,
      text: 'Top 2 Box'
    })
  }
  if (len > 3) {
    const [av0, av1, av2] = answerVariants
    chartTopsMapping.push({
      value: reversed ? 'bottom3' : 'top3',
      listText: `Top 3 Box (A${av0.position}: ${av0.text}, A${av1.position}: ${av1.text}, A${av2.position}: ${av2.text})`,
      text: 'Top 3 Box'
    })
  }
  if (len > 2) {
    const [av0, av1] = answerVariants
    chartTopsMapping.push({
      value: reversed ? 'bottom2w' : 'top2w',
      listText: `T-Weighted (100% A${av0.position}: ${av0.text}, 50% A${av1.position}: ${av1.text})`,
      text: 'T-Weighted'
    })
  }

  if (len > 1) {
    const av = answerVariants[len - 1]
    chartTopsMapping.push({
      value: reversed ? 'top1' : 'bottom1',
      listText: `Top 1 Box (A${av.position}: ${av.text})`,
      text: 'Top 1 Box'
    })
  }
  if (len > 2) {
    const av1 = answerVariants[len - 2]
    const av2 = answerVariants[len - 1]
    chartTopsMapping.push({
      value: reversed ? 'top2' : 'bottom2',
      listText: `Top 2 Box (A${av1.position}: ${av1.text}, A${av2.position}: ${av2.text})`,
      text: 'Top 2 Box'
    })
  }
  if (len > 3) {
    const av1 = answerVariants[len - 3]
    const av2 = answerVariants[len - 2]
    const av3 = answerVariants[len - 1]
    chartTopsMapping.push({
      value: reversed ? 'top3' : 'bottom3',
      listText: `Top 3 Box (A${av1.position}: ${av1.text}, A${av2.position}: ${av2.text}, A${av3.position}: ${av3.text})`,
      text: 'Top 3 Box'
    })
  }
  if (len > 2) {
    const av1 = answerVariants[len - 2]
    const av2 = answerVariants[len - 1]
    chartTopsMapping.push({
      value: reversed ? 'top2w' : 'bottom2w',
      listText: `T-Weighted (50% A${av1.position}: ${av1.text}, 100% A${av2.position}: ${av2.text})`,
      text: 'T-Weighted'
    })
  }

  return chartTopsMapping
}

export const getHelpText = (viewMode, topsMode) => {
  if ('boxScore' === viewMode) {
    return HELP_OPTIONS?.[viewMode]?.[topsMode] || HELP_OPTIONS?.[viewMode] || ''
  }
  return HELP_OPTIONS?.[viewMode] || ''
}
